"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var i18n_1 = require("../../i18n");
var Translate = function (props) {
    return (React.createElement("span", null, exports.translate(props)));
};
exports.translate = function (props) { return i18n_1.default.t(props.forKey, props.overrides) || props.forKey; };
exports.default = Translate;
//# sourceMappingURL=Translate.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Translate/Translate.js
// module id = 35
// module chunks = 0 1